import { AntDesign } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import { Sale } from "@towersystems/roam-common/lib/generated-types";
import { Pressable } from "react-native";
import { Colors, Spacings, View } from "react-native-ui-lib";
import { Badge, Status } from "@towersystems/roam-common-native";
import { moneyToFormattedString } from "../../../../utilities/money";
import { SaleScreenNavigationProp } from "../../screens/SaleScreen";
import { Text } from "@towersystems/roam-common-native";
import { SaleState } from "../../../../utilities/data/model/Sale";
import {
  bankersRound,
  formatDateToCalendar,
  fullDateTimeFormat,
} from "@towersystems/roam-common/lib/shared-utils";

export interface SaleResourceListItemProps {
  sale: Sale;
}

export const SaleResourceListItem = ({ sale }: SaleResourceListItemProps) => {
  const navigation = useNavigation<SaleScreenNavigationProp["navigation"]>();

  const isCartSale =
    sale.state === SaleState.SAVED && sale.source == "WEB_CHECKOUT";

  /*
   5/2/26 - At some point purchase order number was incorrectly defaulting to the invoice sequence number which 
   was causing confusion as they are not the same thing, so removing that default for now.
  */
  const purchaseOrderNumber =
    sale.purchaseOrderNumber &&
    sale.purchaseOrderNumber !== sale.invoiceSequence?.toString()
      ? ` / PO#${sale.purchaseOrderNumber}`
      : null;

  return (
    <Pressable
      onPress={() =>
        navigation.navigate("SaleScreen", {
          saleId: sale.id,
        })
      }
    >
      <View flex row style={{ justifyContent: "space-between" }}>
        <View style={{ width: "60%" }}>
          <Text variant="heading" fontWeight="medium">
            {isCartSale
              ? "Cart Session"
              : `#${sale.invoiceNumber}${purchaseOrderNumber || ""}`}
          </Text>
          <Text
            variant="heading4"
            color="subdued"
            numberOfLines={1}
            ellipsizeMode="head"
          >
            {`${formatDateToCalendar(sale.saleDate, fullDateTimeFormat)}, at ${
              sale.location?.name || "No Location"
            }`}
          </Text>
        </View>
        <View row style={{ alignItems: "flex-end" }}>
          <View style={{ alignItems: "flex-end" }}>
            <Text variant="heading1">
              {moneyToFormattedString(bankersRound(sale.totalPrice))}
            </Text>
            <View row>
              {sale.isReturn ? <Badge>REFUND</Badge> : undefined}
              <Badge
                style={{ marginLeft: Spacings.s2 }}
                status={sale.state as Status}
              >
                {sale.state}
              </Badge>
            </View>
          </View>
          <View>
            <Text fontWeight="bold" variant="heading1">
              <AntDesign
                style={{ marginLeft: Spacings.s4, color: Colors.Text }}
                name="right"
                size={24}
              />
            </Text>
          </View>
        </View>
      </View>
      {sale.customer ? (
        <View style={{ marginTop: Spacings.s2 }}>
          <Text fontWeight="bold" variant="heading5" color="subdued">
            {sale.customer.firstName} {sale.customer.lastName} (
            {sale.customer.emailAddress})
          </Text>
        </View>
      ) : null}
      {sale.note ? (
        <View style={{ marginTop: Spacings.s2 }}>
          <Text variant="heading4" color="subdued">
            "{sale.note}"
          </Text>
        </View>
      ) : null}
    </Pressable>
  );
};
